import React, { Component } from 'react';
import MetaDecorator from '../components/MetaDatos/MetaDecorator';
import ReactGA from 'react-ga';

    // Configuración de Google Analytics
    const gaTrackingId = "G-ZH19XSWM9N"; 
    ReactGA.initialize (gaTrackingId); 
    ReactGA.pageview ("/404");

    class Page404 extends Component{
      render(){
        
        return (
              <div className="404 vh-100">
                <MetaDecorator 
                    meta_title="metaTitle_404"
                    meta_description="metaDescription_404"
                    url="404"
                />
                <section className="error_two_area sec--area">
                  <div className="container">
                    <div className="row align-items-center flex-column">
                      <h2 className='w_color f_size_60 f_700'>Error 404. We can’t find the page you’re looking for.</h2>
                      <p className='p_color f_600 f_size_20'>
                        Sorry for the inconvenience. 
                      </p>
                      
                      <a href="https://www.dreamcodesoft.com" className="learn_btn"> Back to Home Page<i className="ti-arrow-right"></i></a>
                    
                    </div>
                  </div>
                </section>
              </div>
		
		);
	}
}	

export default Page404;
